import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import { ContentProvider } from './cms/ContentProvider';
import MarketingNav from './components/marketing/MarketingNav';
import MarketingFooter from './components/marketing/MarketingFooter';

import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import PrepPage from './pages/PrepPage';
import PrepExamPage from './pages/PrepExamPage';
import PathwaysPage from './pages/PathwaysPage';
import PracticumsPage from './pages/PracticumsPage';
import ExpressPage from './pages/ExpressPage';
import SuitesPage from './pages/SuitesPage';
import MedSchoolPage from './pages/MedSchoolPage';
import AudiencesPage from './pages/AudiencesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import PrivacyPage from './pages/PrivacyPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminPage from './pages/AdminPage';

import './App.css';

/* The public site: navigation, page, footer. */
function MarketingShell() {
  return (
    <div className="flex min-h-screen flex-col bg-paper text-bright">
      <MarketingNav />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products/prep" element={<PrepPage />} />
          <Route path="/products/prep/:examId" element={<PrepExamPage />} />
          <Route path="/products/pathways" element={<PathwaysPage />} />
          <Route path="/products/practicums" element={<PracticumsPage />} />
          <Route path="/products/express" element={<ExpressPage />} />
          <Route path="/products/suites" element={<SuitesPage />} />
          <Route path="/products/medschool" element={<MedSchoolPage />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/who-its-for" element={<AudiencesPage />} />
          <Route path="/boards" element={<Navigate to="/who-its-for#boards" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          {/* Redirects from the previous site's URLs */}
          <Route path="/platform" element={<Navigate to="/products/suites" replace />} />
          <Route path="/modules" element={<Navigate to="/products/suites" replace />} />
          <Route path="/modules/:slug" element={<Navigate to="/products/suites" replace />} />
          <Route path="/lms" element={<Navigate to="/products/suites" replace />} />
          <Route path="/practicums" element={<Navigate to="/products/practicums" replace />} />
          <Route path="/prerounds" element={<Navigate to="/products/medschool" replace />} />
          <Route path="/demo" element={<Navigate to="/contact" replace />} />
          <Route path="/investors" element={<Navigate to="/about" replace />} />
          <Route path="/security" element={<Navigate to="/who-its-for#boards" replace />} />
          <Route path="/login" element={<Navigate to="/contact" replace />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <MarketingFooter />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ContentProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* The content console renders on its own, without the site chrome. */}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<MarketingShell />} />
          </Routes>
        </Router>
      </ContentProvider>
    </HelmetProvider>
  );
}

export default App;
